import { useQuery } from "@tanstack/react-query";

import { SubDealersQueryKeys } from "./subDealersQueryKeys";
import {
  getSubDealersPlayers,
  GetSubDealersPlayersQueryParams,
} from "@/api/subDealers";
import { getPlayers } from "@/api/users/getPlayers";

type Options = GetSubDealersPlayersQueryParams;

export const useSubDealersPlayers = (
  options: Options & { enabled: boolean | undefined }
) => {
  return useQuery({
    queryKey: [SubDealersQueryKeys.Players, options],
    enabled: options ? options.enabled : true,
    queryFn: ({ signal }) => {
      const params = {
        subDealerUsernames: options.subDealerUsernames,
        subDealerIds: options.subDealerIds,
      };
      return getSubDealersPlayers({ signal, params });
    },
  });
};

export const usePlayers = () => {
  return useQuery({
    queryKey: [SubDealersQueryKeys.GetPlayers],
    enabled: true,
    queryFn: ({ signal }) => {
      return getPlayers({ signal, params: {} });
    },
  });
};
